export function DataURLtoFile(data: any, type: any) {
    // eslint-disable-next-line prefer-const
    let bytes = window.atob(data), n = bytes.length,u8arr = new Uint8Array(n)
    while(n--){
        u8arr[n]=bytes.charCodeAt(n)
    }
    return new Blob([u8arr], {type: type})
}

export function ExportExcel(data: any, type: any, name: string) {
    const _down = DataURLtoFile(data, type)
    const a = document.createElement('a')
    a.download = name
    a.href = window.URL.createObjectURL(_down)
    a.click()
    document.body.appendChild(a)
}

export function ExportExcel_Order(data: any, type: any, name: string) {
    const _down = DataURLtoFile(data, type)
    const a = document.createElement('a')
    a.download = name + (type === 'application/pdf' ? ".pdf" : ".ofd")
    a.href = window.URL.createObjectURL(_down)
    a.click()
    document.body.appendChild(a)
}
